import { useMemo } from 'react';
import moment from 'moment';
import { formatCurrency } from '../../../CommonUtils/formatNumber';
import { usePortfolioSummaryQuery } from '../../api/usePortfolioSummaryQuery';
import { useRouteParams } from '../../hooks/useRouteParams';
import { usePeriod } from '../../hooks/usePeriod';
import { today } from '../../AccountPerformanceReporting.constants';

export const useMarketValue = () => {
  const { accountId, clientId, groupId } = useRouteParams();

  const period = usePeriod();

  const queryInfo = usePortfolioSummaryQuery({
    clientId,
    period: period.value,
    startDate: period.dates[0],
    endDate: period.dates[1],
    accountId,
    groupId,
  });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { marketValue } = queryInfo.data;

    const formattedDate =
      period.dates[1] === today ? 'Today' : moment(period.dates[1]).format('M/D/YYYY');

    return {
      label: `Market Value as of ${formattedDate}`,
      value:
        typeof marketValue === 'number' ? formatCurrency(marketValue, { decimalPlaces: 2 }) : null,
    };
  }, [period.dates, queryInfo.data]);

  return { ...queryInfo, data };
};
